import type { EventMetadata, EventName } from '../metadata/eventMetadata';
import type { BlizzardEvent } from '@snapchat/blizzard-schema-events';
import type { AnyEventBase } from '@snapchat/blizzard-schema';

/**
 * Container for event data and associated metadata. The event data should generally be considered
 * opaque unless you are aware of its format.
 */
export interface Event<T> {
  eventName: EventName;
  data: T;
  metadata: EventMetadata;
}

/** A union type representing the types of events that the Blizzard SDK supports. */
export type EventUnionType = AnyEventBase | BlizzardEvent;

// TODO: fix these types in followup PR changing to use AnyEvent everywhere
/** Whether the object has 'eventName' property. */
export function isEvent<T>(item: object): item is Event<T> {
  return !!item && 'eventName' in item;
}

/** @returns True if the provided {@link item} is a {@link BlizzardEvent} (i.e. protobuf schema). */
export function isProtoEventData(item: BlizzardEvent | AnyEventBase): item is BlizzardEvent {
  return 'toProto' in item;
}
